import {SortBy} from './Filter';
import React, {RefObject} from 'react';
import {AQLQueries, AQLQuery} from './AQL/query.ts';
import {Collection, SavedSearch, Workspace} from '../../../types.ts';

export type TSearchContext = {
    workspaceId?: string;
    selectCollection: (
        id: string | undefined,
        collection?: Collection | undefined,
        forceReload?: boolean
    ) => void;
    selectWorkspace: (
        id: string | undefined,
        workspace?: Workspace | undefined,
        forceReload?: boolean
    ) => void;
    collections: string[];
    workspaces: string[];
    query: string;
    setQuery: (query: string, force?: boolean) => void;
    searchId?: string | undefined;
    setSearchId: (id: string | undefined) => void;
    loadSearch: (savedSearch: SavedSearch) => void;
    inputQuery: RefObject<string>;
    setInputQuery: (query: string) => void;
    geolocation?: string | undefined;
    setGeoLocation: (position: string | undefined) => void;
    reset: () => void;
    conditions: AQLQueries;
    upsertCondition: (query: AQLQuery) => void;
    removeCondition: (query: AQLQuery) => void;
    resetWithCondition: (query: AQLQuery) => void;
    sortBy: SortBy[];
    setSortBy: (newSortBy: SortBy[]) => void;
    searchChecksum?: string;
    reloadInc: number;
    hasSearch: boolean;
};

export const SearchContext = React.createContext<TSearchContext | undefined>(
    undefined
);
